import { ITheme } from "@app/app";
import { ICurrency, ILanguage } from "@app/common/types";
import { IProperty, IPropertyTheme } from "@app/property/types";

export enum IPropertyGroupMethod {
    UrlEndsWith = "UrlEndsWith",
    UrlStartsWith = "UrlStartsWith",
    UrlContains = "UrlContains",
    WindowObject = "WindowObject",
}

interface IPropertyDetection {
    method: IPropertyGroupMethod;
    properties: {
        [key: string]: string;
    };
    windowKey?: string;
}

export interface IPropertyGroup {
    domain: string;
    properties: IProperty[];
    property_detection: IPropertyDetection;
    fallback_theme_config: ITheme;
    fallback_theme: IPropertyTheme;
    fallback_languages: ILanguage[];
    fallback_currencies: ICurrency[];
    current_page: number;
    has_more_data: boolean;
}
